// takes a row of array based result and turns in into an array of objects
export function convertToObjects<T>(fields: string[], res: Array<string | number>[]): T[] {
  const result: any[] = []
  for (const row of res) {
    const item: Record<string, any> = {}
    result.push(item)
    for (let i = 0; i < fields.length; i++) {
      const value = row[i]
      item[fields[i]] = fields[i] === 'h3_index' ? value : typeof value === 'string' ? parseFloat(value) : value
    }
  }
  return result
}
